module.exports = __webpack_public_path__ + "static/media/lista-create-procedure.8be5a48b.mp4";